export interface Category {
  title: string;
  description: string;
  icon: 'engine' | 'gearbox' | 'axle' | 'fuel' | 'turbo' | 'rare';
}

export const categories: Category[] = [
  {
    title: 'Двигатели',
    description:
      'Новые, контрактные и восстановленные дизельные двигатели в сборе и различной комплектации.',
    icon: 'engine',
  },
  {
    title: 'Коробки передач',
    description:
      'Механические, автоматические и роботизированные КПП для грузовой и специальной техники.',
    icon: 'gearbox',
  },
  {
    title: 'Мосты и редукторы',
    description: 'Передние и задние мосты, главные передачи, редукторы и комплектующие.',
    icon: 'axle',
  },
  {
    title: 'Топливная аппаратура',
    description: 'Форсунки, ТНВД, насосы, рампы и другие элементы топливной системы.',
    icon: 'fuel',
  },
  {
    title: 'Турбокомпрессоры',
    description: 'Турбины и комплектующие для дизельных двигателей грузовой техники.',
    icon: 'turbo',
  },
  {
    title: 'Редкие запчасти',
    description:
      'Труднодоступные детали зарубежных производителей, включая позиции брендов, ушедших с российского рынка.',
    icon: 'rare',
  },
];

export const manufacturers = [
  'КАМАЗ', 'МАЗ', 'Урал', 'Sitrak', 'Shacman', 'FAW', 'HOWO', 'Dongfeng',
  'Volvo', 'Scania', 'Mercedes-Benz', 'MAN', 'DAF', 'Iveco',
  'Caterpillar', 'Komatsu', 'Hitachi', 'John Deere', 'JCB', 'Hyundai', 'Doosan',
];

export interface Advantage {
  title: string;
  description: string;
}

export const advantages: Advantage[] = [
  {
    title: 'Подбор за 1 рабочий день',
    description: 'Проверим доступные варианты и подготовим предложение.',
  },
  {
    title: 'Проверка совместимости',
    description: 'Подбираем агрегаты по VIN, серийному номеру и фотографии шильдика.',
  },
  {
    title: 'Доставка по России',
    description: 'Отправляем двигатели и запчасти транспортными компаниями в регионы РФ.',
  },
  {
    title: 'Поставка за 14–20 дней',
    description:
      'Большинство агрегатов со складов поставщиков доставляем в течение 14–20 дней.',
  },
  {
    title: 'Гарантия качества',
    description: 'Работаем с проверенными поставщиками и заранее фиксируем условия гарантии.',
  },
  {
    title: 'Оплата с НДС и без НДС',
    description: 'Работаем с юридическими и физическими лицами.',
  },
];

export const workflow = [
  {
    step: '01',
    text: 'Клиент отправляет VIN, номер агрегата или фотографию шильдика.',
  },
  {
    step: '02',
    text: 'Мы проверяем модификацию, совместимость и наличие.',
  },
  {
    step: '03',
    text: 'Предлагаем варианты по цене, состоянию и срокам.',
  },
  {
    step: '04',
    text: 'Организуем оформление, оплату и доставку.',
  },
];
